import { Stack, Typography } from '@mui/material';
import {
  StyledCardContainer,
  CardContainerIcon,
  ImageContainer,
} from './Filters.components';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import { useNavigate } from 'react-router-dom';

export type ExperienceCardProps = {
  id: string;
  image: string;
  label: string;
  description: string;
  email: string;
  phone: string;
};

export const ExperienceCard = (props: ExperienceCardProps) => {
  const navigate = useNavigate();

  const handleEdit = (id: string) => {
    navigate('edit', {
      state: {
        id: id,
      },
    });
  };

  return (
    <StyledCardContainer onClick={() => handleEdit(props.id)}>
      <ImageContainer>
        <BrokenImageIcon fontSize="large" />
      </ImageContainer>
      <Typography fontSize={16} color="red300">
        {props.label}
      </Typography>
      <Typography fontSize={13}>{props.description}</Typography>
      <Stack direction="row" alignItems="center" gap={1}>
        <CardContainerIcon>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.2709 8.99981C13.2688 8.32749 13.1967 7.65721 13.0559 6.9998H14.8559C14.7632 6.72559 14.6512 6.45826 14.5209 6.19981H12.8459C12.531 5.14783 12.0426 4.15585 11.4009 3.2648C10.9909 3.09241 10.5634 2.96499 10.1259 2.8848C11.005 3.82942 11.6686 4.95365 12.0709 6.17981H9.37586V2.7998H8.62586V6.18481H5.93086C6.3339 4.95643 6.99927 3.8304 7.88086 2.8848C7.44525 2.96366 7.01944 3.08939 6.61086 3.2598C5.96659 4.14712 5.47484 5.13568 5.15586 6.18481H3.47086C3.33814 6.44797 3.22452 6.72034 3.13086 6.9998H4.94586C4.805 7.65721 4.73295 8.32749 4.73086 8.99981C4.73224 9.73519 4.8161 10.4681 4.98086 11.1848H3.21086C3.3143 11.4651 3.43796 11.7375 3.58086 11.9998H5.19586C5.50196 12.9577 5.95576 13.8619 6.54086 14.6798C6.95985 14.8595 7.39754 14.992 7.84586 15.0748C7.02982 14.1847 6.40224 13.1387 6.00086 11.9998H8.63086V15.1698H9.38086V11.9998H12.0009C11.5981 13.1392 10.9688 14.1852 10.1509 15.0748C10.6013 14.9891 11.0407 14.8533 11.4609 14.6698C12.045 13.855 12.4988 12.9542 12.8059 11.9998H14.4059C14.5481 11.7423 14.6718 11.475 14.7759 11.1998H13.0009C13.1735 10.479 13.264 9.74097 13.2709 8.99981ZM8.62586 11.1848H5.75586C5.40385 9.80873 5.38841 8.36811 5.71086 6.98481H8.62586V11.1848ZM12.2459 11.1848H9.37586V6.9998H12.2909C12.4345 7.65667 12.5049 8.32743 12.5009 8.99981C12.5049 9.73579 12.4193 10.4695 12.2459 11.1848Z"
              fill="currentColor"
            />
            <path
              d="M9 1C7.41775 1 5.87103 1.46919 4.55544 2.34824C3.23985 3.22729 2.21447 4.47672 1.60897 5.93853C1.00347 7.40034 0.84504 9.00887 1.15372 10.5607C1.4624 12.1126 2.22433 13.538 3.34315 14.6569C4.46197 15.7757 5.88743 16.5376 7.43928 16.8463C8.99113 17.155 10.5997 16.9965 12.0615 16.391C13.5233 15.7855 14.7727 14.7602 15.6518 13.4446C16.5308 12.129 17 10.5823 17 9C17 6.87827 16.1571 4.84344 14.6569 3.34315C13.1566 1.84285 11.1217 1 9 1ZM9 16C7.61553 16 6.26216 15.5895 5.11101 14.8203C3.95987 14.0511 3.06266 12.9579 2.53285 11.6788C2.00303 10.3997 1.86441 8.99224 2.13451 7.63437C2.4046 6.2765 3.07129 5.02922 4.05026 4.05025C5.02922 3.07128 6.2765 2.4046 7.63437 2.1345C8.99224 1.86441 10.3997 2.00303 11.6788 2.53284C12.9579 3.06266 14.0511 3.95986 14.8203 5.11101C15.5895 6.26215 16 7.61553 16 9C16 10.8565 15.2625 12.637 13.9498 13.9497C12.637 15.2625 10.8565 16 9 16Z"
              fill="currentColor"
            />
          </svg>
        </CardContainerIcon>
        <Stack>
          <Typography fontSize={13}>{props.email}</Typography>
          <Typography fontSize={12} color="gray300">
            Email
          </Typography>
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center" gap={1}>
        <CardContainerIcon>
          <svg
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.28898 2.41952L5.64368 2.61392C5.0691 2.78719 4.55598 3.121 4.16471 3.57605C3.77343 4.0311 3.52029 4.58846 3.43508 5.18252C3.16778 7.04372 3.76538 9.21992 5.20628 11.7156C6.64358 14.205 8.22578 15.8088 9.96728 16.5108C10.5268 16.7363 11.1394 16.7964 11.7321 16.6839C12.3248 16.5715 12.8728 16.2911 13.3108 15.8763L13.7986 15.4137C14.1153 15.1139 14.3125 14.7093 14.3534 14.2751C14.3943 13.8409 14.2761 13.4067 14.0209 13.053L12.8005 11.361C12.6355 11.1326 12.4032 10.9615 12.136 10.8718C11.8689 10.782 11.5804 10.7781 11.311 10.8606L9.46508 11.4249L9.41738 11.4339C9.21398 11.4636 8.74418 11.0235 8.15918 10.0101C7.54718 8.94992 7.42118 8.32981 7.58948 8.16961L8.52818 7.29391C8.87146 6.97393 9.10594 6.55451 9.19875 6.0945C9.29156 5.63449 9.23804 5.15696 9.04568 4.72892L8.44988 3.40502C8.27073 3.00662 7.95281 2.68698 7.5554 2.50566C7.15799 2.32434 6.7073 2.29372 6.28898 2.41952ZM7.63088 3.77402L8.22488 5.09791C8.34057 5.35462 8.37292 5.64112 8.31738 5.91716C8.26185 6.1932 8.12123 6.44491 7.91528 6.63691L6.97388 7.51351C6.37088 8.08411 6.57068 9.05792 7.38068 10.4601C8.14208 11.7795 8.83688 12.4311 9.58388 12.3177L9.69548 12.2943L11.5747 11.721C11.6645 11.6934 11.7607 11.6946 11.8498 11.7245C11.9389 11.7544 12.0164 11.8114 12.0715 11.8875L13.2919 13.5795C13.4197 13.7563 13.4789 13.9735 13.4585 14.1907C13.4382 14.4079 13.3396 14.6103 13.1812 14.7603L12.6925 15.2229C12.3796 15.519 11.9883 15.7191 11.565 15.7994C11.1418 15.8796 10.7044 15.8367 10.3048 15.6756C8.77658 15.06 7.33208 13.5957 5.98658 11.2656C4.63748 8.93012 4.09118 6.94382 4.32608 5.31032C4.38689 4.8859 4.56769 4.4877 4.8472 4.16259C5.12671 3.83747 5.49329 3.59899 5.90378 3.47522L6.54908 3.28082C6.7583 3.21795 6.98323 3.23332 7.18195 3.32407C7.38066 3.41481 7.53958 3.57474 7.62908 3.77402"
              fill="#EA5455"
            />
          </svg>
        </CardContainerIcon>
        <Stack>
          <Typography fontSize={13}>{props.phone}</Typography>
          <Typography fontSize={12} color="gray300">
            Phone
          </Typography>
        </Stack>
      </Stack>
    </StyledCardContainer>
  );
};
